import { render } from "./CodeField.vue?vue&type=template&id=f8794f2a"
import script from "./CodeField.vue?vue&type=script&lang=js"
export * from "./CodeField.vue?vue&type=script&lang=js"

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CodeField.vue"]])

export default __exports__